export enum Status {
  Accepted = 'Accepted',
  Incomplete = 'Incomplete',
  Pending = 'Pending',
  AttentionRequired = 'Attention Required',
  Locked = 'Locked',
  Unset = '',
}
